import { VerticalCarousel } from "./vertical-carousel/VerticalCarousel";


function Vertical_carousel() {
  const data = [
    {
      images: [
        "/images/diverse/3.png",
        "/images/rigging/F34toptube.png",
        "/images/diverse/3.png",
      ],
    },
    {
      images: [
        "/images/ljud/sh55.png",
        "/images/kabel/UC32A.png",
        "/images/kabel/defender.png",
         ],
    },
    {
      images: [
        "/images/diverse/komradio.png",
        "/images/rigging/F34tower.png",
        "/images/ljud/sq6.png",
       ],
    },
    {
      images: [
        "/images/kabel/defender.png",
        "/images/ljud/e906.png",
        "/images/kabel/defender.png",
       ],
    },
    {
      images: [
        "/images/rigging/F32135deg.png",
        "/images/diverse/komradio.png",
        "/images/rigging/F34050.png",
        ],
    },
    {
      images: [
        "/images/ljud/dt168.png",
        "/images/ljus/blinder.png",
        "/images/ljus/Beamball.png",
       ],
    },
    {
      images: [
        "/images/ljud/CQ-18T-Top.png",
        "/images/ljud/dvx8.png",
        "/images/ljud/komplete_system.png",
    ],
    },
    {
      images: [
        "/images/rigging/gizmo.png",
        "/images/kabel/defender.png",
        "/images/rigging/handspel.png",
       ],
    },
    {
      images: [
        "/images/ljus/slimpar18.png",
        "/images/rigging/F34100B.png",
        "/images/ljus/ACL360.png",
       ],
    },
    {
      images: [
        "/images/ljus/avotitanmobile.png",
        "/images/ljud/doughtytapp.png",
        "/images/ljud/beta58.png", ],
    },
    {
      images: [
        "/images/ljud/alghorn.png",
        "/images/ljus/TRIphase.png",
        "/images/kabel/defender.png", ],
    },
    {
      images: [
        "/images/ljus/simpledesk24.png",
        "/images/ljud/21339.png",
        "/images/diverse/3.png", ],
    },
    {
      images: [
        "/images/diverse/komradio.png",
        "/images/ljud/e604.png",
        "/images/kabel/defender.png", ],
    },
    {
      images: [
        "/images/kabel/defender.png",
        "/images/ljus/Varytec300.png",
        "/images/ljus/ledbar.png", ],
    },
    {
      images: [
        "/images/ljus/megatri60.png",
        "/images/rigging/F31105B.png",
        "/images/rigging/F32150B.png", 
       ],
    },
    {
      images: [
        "/images/ljus/signalhantering.png",
        "/images/ljus/F31.png",
        "/images/rigging/F32dogbone.png",
        ],
    },
    {
      images: [
        "/images/ljus/F31.png",
        "/images/ljud/dva12case.png",
        "/images/kabel/defender.png", ],
    },
    {
      images: [
        "/images/rigging/burton50mm.png",
        "/images/rigging/F31.png",
        "/images/kabel/defender.png",
       ],
    },
  ];
  return (
          <VerticalCarousel images={data}  />
    
  );
}

export default Vertical_carousel;
